(function () {
if (!customElements.get('rebuy-cx-slider-init')) {
    class RebuyCxSliderInit extends HTMLElement {
        domReadyBound = false;
        /** @type {ReturnType<typeof setTimeout> | null} */
        tryInitTimer = null;
        /** @type {MutationObserver | null} */
        rebuyObserver = null;

        constructor() {
            super();
            this.initRebuy = this.initRebuy.bind(this);
            this.initRebuySlider = this.initRebuySlider.bind(this);
            this.tryInitRebuySlider = this.tryInitRebuySlider.bind(this);
            this.observeRebuy = this.observeRebuy.bind(this);
            this.onRebuyReady = this.onRebuyReady.bind(this);
        }

        connectedCallback() {
            if (!this.dataset.rebuyWidgetId) {
                return;
            }

            if (document.readyState === 'loading') {
                this.domReadyBound = true;
                document.addEventListener('DOMContentLoaded', this.observeRebuy);
            } else {
                this.observeRebuy();
            }
            document.addEventListener('cart-drawer:open', this.initRebuy);
            document.addEventListener('rebuy.ready', this.onRebuyReady);
        }

        disconnectedCallback() {
            if (this.domReadyBound) {
                document.removeEventListener('DOMContentLoaded', this.observeRebuy);
                this.domReadyBound = false;
            }
            document.removeEventListener('cart-drawer:open', this.initRebuy);
            document.removeEventListener('rebuy.ready', this.onRebuyReady);
            if (this.tryInitTimer) {
                clearTimeout(this.tryInitTimer);
                this.tryInitTimer = null;
            }
            if (this.rebuyObserver) {
                this.rebuyObserver.disconnect();
                this.rebuyObserver = null;
            }
        }

        /**
         * Rebuy renders a widget only into a container that is in the page, then fires rebuy.ready
         * (once per widget), so this is the moment to start watching a container that was not there yet.
         */
        onRebuyReady() {
            this.observeRebuy();
            this.initRebuySlider();
        }

        /** @returns {boolean} True when Rebuy already injected product-card shells (loading or loaded). */
        rebuyWidgetHasProductCards() {
            const REBUY_SELECTOR = `[data-rebuy-id="${this.dataset.rebuyWidgetId}"]`;
            const container = document.querySelector(REBUY_SELECTOR);
            if (!container) return false;

            return container.querySelectorAll('.product-card').length > 0;
        }

        initRebuy() {
            if (this.rebuyWidgetHasProductCards()) {
                this.initRebuySlider();
                return;
            }

            const rebuy = window.Rebuy;
            if (!rebuy || typeof rebuy.init !== 'function') return;

            try {
                rebuy.init({
                    id: this.dataset.rebuyWidgetId
                });
            } catch (e) {}
        }

        removeTjcPlusMembershipCards(container) {
            if (!(container instanceof Element)) return;
            container.querySelectorAll('[data-tjc-membership="true"]').forEach((match) => {
                const card = match.closest('.custom-container__card, .rebuy-product-block, .rebuy-product-item');
                if (card) {
                    card.remove();
                    return;
                }
                if (match.tagName === 'PRODUCT-CARD') {
                    match.remove();
                }
            });
        }

        initRebuySlider() {
            const rebuyWidgetBlock = document.querySelector('.rebuy-product-slider-block[data-rebuy-widget-id="' + this.dataset.rebuyWidgetId + '"]');
            if (!rebuyWidgetBlock) {
                return;
            }
            const REBUY_SELECTOR = `[data-rebuy-id="${this.dataset.rebuyWidgetId}"]`;
            const container = document.querySelector(REBUY_SELECTOR);
            if (container) {
                this.removeTjcPlusMembershipCards(container);
            }
            const productCards = document.querySelectorAll(REBUY_SELECTOR + ' .product-card').length;
            if (productCards > 0) {
                rebuyWidgetBlock.classList.remove('hidden');
            }
        }

        tryInitRebuySlider() {
            if (this.tryInitTimer) {
                clearTimeout(this.tryInitTimer);
            }

            this.tryInitTimer = setTimeout(() => {
                this.tryInitTimer = null;

                const REBUY_SELECTOR = `[data-rebuy-id="${this.dataset.rebuyWidgetId}"]`;
                const SLIDER_SELECTOR = '[data-cx-card-slider="true"]';
                const container = document.querySelector(REBUY_SELECTOR);
                if (!container || !container.querySelector(SLIDER_SELECTOR)) return;
                if (typeof document.dispatchEvent !== 'function') return;
                try {
                    document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { target: container } }));
                } catch (e) {}
            }, 200);
        }

        observeRebuy() {
            if (this.rebuyObserver) return;
            const REBUY_SELECTOR = `[data-rebuy-id="${this.dataset.rebuyWidgetId}"]`;

            var container = document.querySelector(REBUY_SELECTOR);
            // F2: no 200 ms polling. A container that is not in the page yet (inside the gate's inert
            // template, or never placed) cannot hold a Rebuy widget; rebuy.ready calls back here once it does.
            if (!container) return;
            this.tryInitRebuySlider();
            this.removeTjcPlusMembershipCards(container);
            this.rebuyObserver = new MutationObserver(() => {
                this.removeTjcPlusMembershipCards(container);
                this.tryInitRebuySlider();
            });
            this.rebuyObserver.observe(container, { childList: true, subtree: true });
            setTimeout(this.tryInitRebuySlider, 800);
            if (typeof window.addEventListener === 'function') {
                window.addEventListener('load', () => this.tryInitRebuySlider());
            }
        }
    }

    customElements.define('rebuy-cx-slider-init', RebuyCxSliderInit);
}
})();
